<template>
  <div>
    <div class="ls_drawer_main_content">
      <Form ref="formData" :model="formData" :rules="rules">
        <!-- NAME -->
        <FormItem prop="name" :label="schema.name.label">
          <Input v-model="formData.name" :placeholder="schema.name.label"/>
        </FormItem>

        <!-- IMAGE -->
        <div v-if="formData.image_url" class="upload_image">
          <img :src="image_url_full"/>
          <div class="upload_image_cover">
            <Icon type="ios-trash-outline" @click.native="deleteImage"></Icon>
          </div>
        </div>

        <Upload
          class="mb-30"
          v-else
          type="drag"
          :action="upload_url"
          :headers="{ Authorization: 'Bearer ' + token }"
          :on-success="onSuccessImageUpload"
        >
          <div style="padding: 20px 0">
            <Icon type="md-cloud-upload" size="50"/>
            <p>Загрузите изображение</p>
          </div>
        </Upload>

        <!-- ADDRESS -->
        <FormItem prop="address" :label="schema.address.label">
          <Input
            type="textarea"
            v-model="formData.address"
            :rows="4"
            :placeholder="schema.address.label"
          />
        </FormItem>

        <!-- DESCRIPTION -->
        <FormItem prop="description" :label="schema.description.label">
          <Input
            type="textarea"
            v-model="formData.description"
            :rows="4"
            :placeholder="schema.description.label"
          />
        </FormItem>

        <!-- LATITUDE -->
        <FormItem prop="latitude" :label="schema.latitude.label">
          <Input
            ref="latInput"
            v-model="formData.latitude"
            :placeholder="schema.latitude.label"
            @keypress.native="preventLatitudeInput"
            :maxlength="7"
          />
        </FormItem>

        <!-- LONGITUDE -->
        <FormItem prop="longitude" :label="schema.longitude.label">
          <Input
            ref="lonInput"
            v-model="formData.longitude"
            :placeholder="schema.longitude.label"
            @keypress.native="preventLongitudeInput"
            :maxlength="8"
          />
        </FormItem>

        <!-- GEO SOURCE -->
        <FormItem prop="geo_source" :label="schema.geo_source.label">
          <Input
            type="textarea"
            v-model="formData.geo_source"
            :rows="4"
            :placeholder="schema.geo_source.label"
          />
        </FormItem>

        <!-- TIMEZONE -->
        <FormItem prop="timezone" :label="schema.timezone.label" class="mb-50">
          <Select v-model="formData.timezone" filterable>
            <Option
              v-for="item in schema.timezone.choices"
              :value="item.value"
              :key="item.value"
            >{{ item.display_name }}
            </Option
            >
          </Select>
        </FormItem>


        <!-- DEFAULT -->
        <FormItem prop="default">
          <div class="switch-custom">
            <i-switch v-model="formData.default"></i-switch>
            <span>{{schema.default.label}}</span>
          </div>

        </FormItem>

        <!-- NULLABLE REST -->
        <FormItem prop="default">
          <div class="switch-custom">
            <i-switch v-model="formData.nullable_rest"></i-switch>
            <span>{{schema.nullable_rest.label}}</span>
          </div>

        </FormItem>
      </Form>
    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button
        type="info"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      >
        <Icon type="md-checkmark"/>
      </Button>
    </div>
  </div>
</template>

<script>
    //import {http, base_url} from '../../http.js'
    import { base_url, server_addr } from "../../http.js";
    import {BaseFormData} from "../../base/base_form_v2.js";

    let _app = BaseFormData();

    _app.data = function () {
        return {
            loading: true,
            baseRules: {},
            excludeFieldsRules: [],
            validForm: false,
            isChanged: false,

            upload_url: base_url + "/store/upload/",

            formData: {
                name: "",
                address: "",
                description: "",
                latitude: null,
                longitude: null,
                geo_source: "",
                default: "",
                image: "",
                image_url: "",
                nullable_rest: true
            },

            formDefaultInitData: {
                name: "",
                address: "",
                description: "",
                latitude: null,
                longitude: null,
                geo_source: "",
                default: "false",
                nullable_rest: true
            },

            formSelectOptions: {
                // type: []
            },
        };
    };

    _app.computed.token = function () {
        return this.$store.state.access_token;
    };
    _app.computed.image_url_full = function() {
        return server_addr + this.formData.image_url;
    };

    // Загрузка и удаление картинки
    _app.methods.onSuccessImageUpload = function(response, filename) {
        // console.log(response);
        this.formData.image = response.filename;
        this.formData.image_url = response.url;
    };
    _app.methods.deleteImage = function() {
        this.formData.image = "";
        this.formData.image_url = "";
    };

    // Блокировка ввода для latitude
    _app.methods.preventLatitudeInput = function(event) {
        const char = String.fromCharCode(event.which);
        const currentValue = event.target.value;

        // Разрешаем только цифры и точку
        if (!/[0-9.]/.test(char)) {
            event.preventDefault();
            return;
        }

        // Блокируем точку как первый символ
        if (char === '.' && currentValue === '') {
            event.preventDefault();
            return;
        }

        // Блокируем вторую точку
        if (char === '.' && currentValue.includes('.')) {
            event.preventDefault();
            return;
        }

        // Не даю ввести после макс значения ничего
        // Блокируем любой ввод если уже введено максимальное значение 90
        if (currentValue === '90') {
            event.preventDefault();
            return;
        }

        const parts = currentValue.split('.');
        
        if (char === '.') {
            if (parts[0] === '0') {
            // Разрешаем точку после 0
            }
            // Для latitude: до точки максимум 2 цифры
            else if (parts[0].length > 2) {
                event.preventDefault();
                return;
            }
        } else {
            // Если вводим цифру
            if (currentValue.includes('.')) {
                // После точки - не больше 4 символов
                if (parts[1] && parts[1].length >= 4) {
                    event.preventDefault();
                    return;
                }
                // Проверяем максимальное значение 90.0000
                // if (intPart === 90 && char !== '0') {
                //     event.preventDefault();
                //     return;
                // }
            } else {
              // Блокируем ведущие нули: если первый символ 0, то следующим может быть только точка
                if (currentValue === '0' && char !== '.') {
                    event.preventDefault();
                    return;
                }
                // До точки - не больше 2 символов для latitude
                if (parts[0].length >= 2) {
                    event.preventDefault();
                    return;
                }
                // Проверяем что не превышаем 90
                const newValue = currentValue + char;
                if (parseInt(newValue) > 90) {
                    event.preventDefault();
                    return;
                }
            }
        }
    };

    // Блокировка ввода для longitude
    _app.methods.preventLongitudeInput = function(event) {
        const char = String.fromCharCode(event.which);
        const currentValue = event.target.value;

        // Разрешаем только цифры и точку
        if (!/[0-9.]/.test(char)) {
            event.preventDefault();
            return;
        }

        // Блокируем точку как первый символ
        if (char === '.' && currentValue === '') {
            event.preventDefault();
            return;
        }

        // Блокируем вторую точку
        if (char === '.' && currentValue.includes('.')) {
            event.preventDefault();
            return;
        }
        
        // Не даю ввести после макс значения ничего
        // Блокируем любой ввод если уже введено максимальное значение 90
        if (currentValue === '180') {
            event.preventDefault();
            return;
        }

        const parts = currentValue.split('.');
        
        if (char === '.') {
            // Блокируем точку если первый символ 0 и нет других цифр
            if (parts[0] === '0') {
                // Разрешаем точку после 0
            }
            // Для longitude: до точки максимум 3 цифры
            else if (parts[0].length > 3) {
                event.preventDefault();
                return;
            }
        } else {
            // Если вводим цифру
            if (currentValue.includes('.')) {
                // После точки - не больше 4 символов
                if (parts[1] && parts[1].length >= 4) {
                    event.preventDefault();
                    return;
                }
                // // Проверяем максимальное значение 180.0000
                // const intPart = parseInt(parts[0]);
                // if (intPart === 180 && char !== '0') {
                //     event.preventDefault();
                //     return;
                // }
            } else {
              // Блокируем ведущие нули: если первый символ 0, то следующим может быть только точка
                if (currentValue === '0' && char !== '.') {
                    event.preventDefault();
                    return;
                }
                // До точки - не больше 3 символов для longitude
                if (parts[0].length >= 3) {
                    event.preventDefault();
                    return;
                }
                // Проверяем что не превышаем 180
                const newValue = currentValue + char;
                if (parseInt(newValue) > 180) {
                    event.preventDefault();
                    return;
                }
            }
        }
    };

    _app.methods.saveAction = function() {
      const normalizeDecimal = (val) => {
        if (val === '' || val === null || val === undefined) return null;
        if (typeof val === 'string') {
          const s = val.trim().replace(',', '.');
          return s === '' ? null : s;
        }
        return val;
      };
      this.formData.latitude = normalizeDecimal(this.formData.latitude)
      this.formData.longitude = normalizeDecimal(this.formData.longitude)

      this.validateForm();
      if (this.validForm) {
        this.save();
      } else {
        this.$Message.error("Некорректно заполнены поля!");
      }
    }

    export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/store/storeForm.vue